import React from 'react';
import { TrafficPatterns, TrafficPatternShortNames } from '../../models/traffic-patterns';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WavesIcon from '@mui/icons-material/Waves';
import StraightIcon from '@mui/icons-material/Straight';
import { Box, SvgIconProps, Typography } from '@mui/material';

interface TrafficPatternIconProps extends SvgIconProps {
    pattern: TrafficPatterns;
}

const getTrafficPatternIcon = (pattern: TrafficPatterns) => {
    switch (pattern) {
        case TrafficPatterns.STEADY:
            return <StraightIcon />;
        case TrafficPatterns.STEADY_WAVE:
            return <WavesIcon />;
        case TrafficPatterns.INCREASE_BY_LEVEL:
            return <TrendingUpIcon />;
        case TrafficPatterns.INCREASE_BY_LEVEL_WITH_BACK_PRESSURE:
            return <ShowChartIcon />;
        default:
            return <StraightIcon />;
    }
};

const getTrafficPatternShortName = (pattern: TrafficPatterns) => {
    return TrafficPatternShortNames[pattern];
}

const TrafficPatternIcon: React.FC<TrafficPatternIconProps> = ({ pattern, ...props }) => {
    return <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        {getTrafficPatternIcon(pattern)}
        <Typography variant="caption" sx={{ fontSize: "0.5rem", lineHeight: 1, marginTop: "2px" }}>{getTrafficPatternShortName(pattern)}</Typography>
    </Box>
};

export default TrafficPatternIcon;
